import styled from 'styled-components';

import media from '../../theme/media';

export const CardContainer = styled.div`
    min-height: 218px;
    box-sizing: border-box;
    margin-bottom: 8px;
    padding: 24px;
    border: 1px solid ${(props) => props.theme.grey_28_tr};
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${media.tablet720} {
        min-height: 296px;
        padding: 32px;
        border-radius: 16px;
        margin-bottom: 16px;
    }
`;

export const CardRow = styled.div`
    display: ${(props) => (props.$fullwidth ? 'block' : 'flex')};
    align-items: ${(props) => (props.$fullwidth ? null : 'center')};
    justify-content: ${(props) => (props.$fullwidth ? null : props.$betweenJustify ? 'space-between' : 'start')};
    margin-bottom: ${(props) => (props.$readOnly ? '32px' : '24px')};

    &:last-child {
        margin-bottom: 0;
    }

    ${media.tablet720} {
        margin-bottom: ${(props) => (props.$readOnly ? '60px' : '32px')};
    }
`;
export const CardNumberBlock = styled.div`
    letter-spacing: 0.5em;
    color: ${(props) => (props.$isCardExpired ? props.theme.grey_40_lc : props.theme.black)};

    ${media.tablet720} {
        font-size: 20px;
        line-height: 32px;
    }
`;
export const BankLogoContainer = styled.div`
    display: inline-flex;
    margin-right: 16px;

    ${media.tablet720} {
        margin-right: 24px;
    }
`;
export const CardPanField = styled.div`
    flex: 1;
`;
export const CardExpiredDate = styled.div`
    width: 80px;
    margin-left: 24px;
    flex-shrink: 0;

    ${media.desktop1920} {
        width: 92px;
    }
`;
export const CardCvv = styled.div`
    width: 80px;
    margin-left: 24px;
    flex-shrink: 0;

    ${media.desktop1920} {
        width: 92px;
    }
`;
export const LogoPaysystem = styled.div`
    display: inline-flex;
    height: 24px;
    opacity: ${(props) => (props.$isCardExpired ? '0.48' : null)};
`;

export const HelpMessage = styled.div`
    margin: 0 16px 8px 16px;

    ${media.tablet720} {
        margin: 0 24px 16px 24px;
    }
`;
